$('.btn.js-gtm').on('click', function (e) {

    $event = $(this).data('gtm_event');

    window.gtmEvent($event, {
        title: $(this).attr('title'),
        href: $(this).attr('href')
    });
});
